"use client";

import { Box, Flex } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";
import { TermsMemberNavButton } from "./TermsMemberNavButton";
import type { TermsMemberNavItem } from "./terms-member-nav-config";

interface TermsMemberMobileNavPickerProps {
  items: TermsMemberNavItem[];
  activeKey: string;
  onChange: (key: string) => void;
}

export const TermsMemberMobileNavPicker = ({
  items,
  activeKey,
  onChange,
}: TermsMemberMobileNavPickerProps) => {
  const theme = useThemeTokens();
  const useEqualSegments = items.length === 2;

  return (
    <Box
      display={{ base: "block", lg: "none" }}
      w="100%"
      minW={0}
      mb={4}
      data-testid="terms-member-nav-mobile"
    >
      <Flex
        w="100%"
        role="tablist"
        aria-label="Waivers on this page"
        data-testid="terms-member-nav-mobile-select"
        gap={1}
        p={1}
        borderRadius="12px"
        borderWidth="1px"
        borderColor={theme.borderGlass.default}
        overflowX={useEqualSegments ? "visible" : "auto"}
        flexWrap="nowrap"
        sx={
          useEqualSegments
            ? undefined
            : {
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                "&::-webkit-scrollbar": { display: "none" },
              }
        }
      >
        {items.map((item) => (
          <TermsMemberNavButton
            key={item.key}
            item={item}
            isActive={activeKey === item.key}
            onClick={() => onChange(item.key)}
            compact
            equalWidth={useEqualSegments}
            showPendingDot
            data-testid={`terms-waiver-${item.key}-tab-mobile`}
          />
        ))}
      </Flex>
    </Box>
  );
};
